import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <Navbar />

      <main className="home-main">
        <section className="hero">
          <div className="hero-inner">
            <div className="video-wrapper">
              <video
                className="promo-video"
                src="/videos/promo.mp4"
                controls
                preload="metadata"
                poster="/images/background.jpg"
              >
                您的浏览器不支持视频播放。
              </video>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
